export enum SaleType {
    isCanceled = 0,
    ProInvoice = 1,
    Offer = 2,
    Sold = 3,
    Reserved = 4,
    DeliveryNote = 5,
    Invoice = 6,
    Printo = 7
}